// material
import { useTheme } from '@mui/material/styles';
import { GlobalStyles as GlobalThemeStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const theme = useTheme();
  const isAmik = theme.isAmik;
  const brand = theme.palette.brand;

  return (
    <GlobalThemeStyles
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box'
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch'
        },
        body: {
          width: '100%',
          height: '100%',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          backgroundColor: isAmik ? brand.paper : theme.palette.background.default,
          color: isAmik ? brand.ink2 : undefined,
          fontSize: '14px',
          lineHeight: 1.5
        },
        // Amik display headings use Poppins (gated on the Amik domain).
        ...(isAmik
          ? {
              'h1, h2, h3, h4, h5, h6': {
                fontFamily: brand.fontDisplay,
                color: brand.ink,
              },
              // Brand helper classes — gradient text and the 4px gradient rule.
              '.amik-gradient-text': {
                background: brand.gradient,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              },
              '.amik-gradient-rule': {
                height: '4px',
                width: '56px',
                borderRadius: '999px',
                background: brand.gradient,
              },
              '.amik-gradient-bg': {
                background: brand.gradient,
              },
            }
          : {}),
        '#root': {
          width: '100%',
          height: '100%'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none'
            }
          }
        },
        textarea: {
          '&::-webkit-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::-moz-placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          },
          '&:-ms-input-placeholder': {
            color: theme.palette.text.disabled
          },
          '&::placeholder': {
            color: theme.palette.text.disabled
          }
        },

        img: { display: 'block', maxWidth: '100%' },

        // Lazy Load Img
        '.blur-up': {
          WebkitFilter: 'blur(0)',
          filter: 'blur(0)'
        },
        '.blur-up.lazyloaded ': {
          WebkitFilter: 'blur(0)',
          filter: 'blur(0)'
        },

        // Price Group Custom Styles
        '.day-fieldset': {
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: theme.spacing(1),
          padding: theme.spacing(2),
          marginBottom: theme.spacing(2),
          backgroundColor: theme.palette.grey[50],
          '& legend': {
            padding: `0 ${theme.spacing(1)}`,
            color: theme.palette.primary.main,
            fontWeight: 600
          }
        },
        '.time-range.VARIABLE .day-fieldset': {
          border: `2px solid ${theme.palette.primary.light}`,
          backgroundColor: theme.palette.primary.lighter || theme.palette.grey[100]
        },
        '.MuiChip-root.checked': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark
          }
        }
      }}
    />
  );
}
